import { css } from '@emotion/core';
import { theme } from '@weave/theme';

export const fullScreenContainerStyle = css`
  height: 100%;
  padding-top: ${theme.spacing(5)};
`;
